import React from 'react';
import Experiences from '../components/Experiences';

const ExperiencesPage: React.FC = () => {
  return (
    <div className="min-h-screen pt-16 md:pt-20">
      <Experiences />
    </div>
  );
};

export default ExperiencesPage;
